import * as types from 'store/modules/hres6me/mutation-types'
import hres6me from 'api/hres6me'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import hres6meLabels from 'assets/labels/hres6me'
import { hres6meColumns } from 'assets/columns/hres6me'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres6meLabels,
    columns: hres6meColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {},
    detail: {
      dteleave: '',
      dtestrt: '',
      dteend: '',
      timstrtDisplay: '',
      timendDisplay: ''
    },
    response: {
      status: '',
      message: ''
    }
  },
  getters: {
    [types.GET_HRES6ME_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES6ME_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES6ME_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES6ME_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES6ME_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES6ME_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES6ME_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES6ME_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES6ME_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES6ME_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES6ME_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES6ME_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES6ME_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES6ME_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES6ME_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES6ME_INDEX_DISP, indexDisp)
      commit(types.SET_HRES6ME_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES6ME_COLUMNS_LABELS] ({ commit }) {
      hres6me.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6ME_COLUMNS, data.labels)
          commit(types.SET_HRES6ME_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES6ME_INDEX] ({ commit }, searchParams) {
      hres6me.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          for (var i = 0; i < data.rows.length; i++) {
            let timstrt = ''
            let timend = ''
            if (typeof data.rows[i].timstrt !== 'undefined') {
              timstrt = (data.rows[i].timstrt.trim() === '') ? '' : ' ' + data.rows[i].timstrt.replace(':', '').substring(0, 2) + ':' + data.rows[i].timstrt.replace(':', '').substring(2, 4)
            }
            if (typeof data.rows[i].timend !== 'undefined') {
              timend = (data.rows[i].timend.trim() === '') ? '' : ' ' + data.rows[i].timend.replace(':', '').substring(0, 2) + ':' + data.rows[i].timend.replace(':', '').substring(2, 4)
            }
            data.rows[i].dtetimperiod = data.rows[i].dtestrt + timstrt + ' - ' + data.rows[i].dteend + timend
          }
          commit(types.SET_HRES6ME_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES6ME_DETAIL] ({ commit }, searchParams) {
      hres6me.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6ME_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.POST_HRES6ME_SAVE_CANCEL] ({ state, commit, dispatch }, { saveParams, searchParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres6me.postSaveCancel(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES6ME_INDEX, searchParams)
              let detailParams = {
                p_dtereq: state.indexSelected.dtereq,
                p_numseq: state.indexSelected.seqno
              }
              dispatch(types.RECEIVED_HRES6ME_DETAIL, detailParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres6me/index.js